import React from 'react';
import { Modal } from '../Common/Modal';
import Spinner from '../Common/Spinner';
import VisitLetterPreviewPanel from './VisitLetterPreviewPanel';
import { getPreviewTitle, normalizeLetterKind } from '../../utils/visitLetterDisplay';
import '../Visits/GenerateVisitLetterModal.css';

const VisitLetterPreviewModal = ({
  open,
  onClose,
  loading,
  content,
  letterKind,
  projectCode,
  siteId,
}) => {
  const kind = normalizeLetterKind(letterKind);
  const header = content?.header ?? content?.Header ?? '';
  const body = content?.body ?? content?.Body ?? '';
  const footer = content?.footer ?? content?.Footer ?? '';
  const visitMeta = content?.visitMeta ?? content?.VisitMeta ?? {};

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      size="large"
      title={getPreviewTitle(letterKind)}
      className="generate-letter-preview-modal"
      footer={(
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
      )}
    >
      {loading ? (
        <Spinner />
      ) : kind === 'piconfirmation' ? (
        <div className="visit-letter-detail-body">
          <div className="letter-content">
            {body ? (
              <div
                className="letter-section letter-raw-content"
                dangerouslySetInnerHTML={{ __html: body }}
              />
            ) : (
              <p className="text-muted">No content stored for this record.</p>
            )}
          </div>
        </div>
      ) : (
        <VisitLetterPreviewPanel
          letterKind={letterKind}
          header={header}
          body={body}
          footer={footer}
          visitMeta={visitMeta}
          projectCode={projectCode}
          siteId={siteId}
        />
      )}
    </Modal>
  );
};

export default VisitLetterPreviewModal;
